import React from "react";
import PropTypes from "prop-types";

import { Router } from "react-router-dom";
import { StaticRouter } from "react-router";
import { createBrowserHistory } from "history";
import { URL_ID_REGEXP } from "config/constants";


export default class UniversalRouter extends React.Component {
  constructor(props) {
    super(props);
    this.trackPageview = this._trackPageview.bind(this);

    if (typeof window !== "undefined") {
      this.history = createBrowserHistory(props);
      this.history.listen(this.trackPageview);
    }
  }

  _trackPageview(location) {
    const routesToNotTrack = [
      "/authorize",
      new RegExp(`^/([A-Za-z0-9-]+-)?${URL_ID_REGEXP}.html`), // don't send on story permalinks, do send on newsletters
    ];

    if (!routesToNotTrack.some((route) => location.pathname.match(route))) {
      window.dataLayer.push({
        "Card": false,
        "event": "GA_Virtual_Pageviews_Event",
      });
    }
  }

  render() {
    if (typeof window === "undefined") {
      return (
        <StaticRouter
          location={this.props.path}
          context={this.props.context}
          children={this.props.children}
        />
      );
    } else {
      return <Router
        children={this.props.children}
        history={this.history}
      />;
    }
  }
}

UniversalRouter.propTypes = {
  children: PropTypes.node,
  path: PropTypes.string,
  context: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/utils/UniversalRouter.js